/*=========================================================================================
  File Name: moduleSettingsState.js
  Description: State of the settings module.
==========================================================================================*/

export default {
  // The selected templated type from the "Settings > Bill Setting > Billing" menu.
  // Values can be one of '', '_2' or '_3'.
  // A value of 'unset' means the template type is not initialized.
  template_type: 'unset',
}
